export const ORDER_DETAIL_ACTION = {
    MOVE_TO_TRIAL_PLAN: 'moveToTrial',
    EXTEND_PLAN: 'extendPlan',
    CHANGE_PLAN: 'changePlan',
}